import type { AuthSession } from '../ports';

export type AuthSessionRegistry = {
  authSession: AuthSession;
  setAuthSession(session: AuthSession | null): void;
};

export function createAuthSessionRegistry(): AuthSessionRegistry {
  let current: AuthSession | null = null;
  let unsubscribeFromCurrent: (() => void) | null = null;
  const sessionExpiredListeners = new Set<() => void>();

  const authSession: AuthSession = {
    async getAccessToken() {
      return current == null ? null : current.getAccessToken();
    },
    async refreshOrNotifySessionExpired() {
      return current == null ? null : current.refreshOrNotifySessionExpired();
    },
    onSessionExpired(listener) {
      sessionExpiredListeners.add(listener);
      return () => {
        sessionExpiredListeners.delete(listener);
      };
    },
    async signOut() {
      await current?.signOut();
    },
  };

  return {
    authSession,
    setAuthSession(session) {
      unsubscribeFromCurrent?.();
      current = session;
      unsubscribeFromCurrent =
        session?.onSessionExpired(() => {
          for (const listener of sessionExpiredListeners) {
            listener();
          }
        }) ?? null;
    },
  };
}
